import { getToken } from 'src/utils/helper';
import axios from '../../../utils/axios';
import { createSlice } from '@reduxjs/toolkit';

const DASHBOARD_DATA_API_URL = `${process.env.REACT_APP_BASE_URL}/dashboard`;

const initialState = {
  dashBoardData: {},
};

// https://apptest.arkchat.com/v1/admin/dashboard

export const dashBoardSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    dashBoardDataSuccess: (state, action) => {
      state.dashBoardData = action.payload.data;
    },
  },
});

export const { dashBoardDataSuccess } = dashBoardSlice.actions;

export const getDashBoardData = () => async (dispatch) => {
  const token = getToken();
  try {
    const response = await axios.get(DASHBOARD_DATA_API_URL, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.data.status) {
        dispatch(dashBoardDataSuccess(response.data))
      return response.data;
    } else {
      return response.data;
    }
  } catch (err) {
    throw new Error(err);
  }
};

export default dashBoardSlice.reducer;
